import * as React from "react";
import { useParams } from "react-router-dom";
import { Card } from "@jhool-io/fe-components";
import Navbar from "../../../components/Navbar/Navbar";
import { useGetConsentByBookingId } from "../hooks/client-forms.queries";
import { FormStatus } from "../types/client-forms.types";
import ConsentFormWrapper from "../components/ConsentFormWrapper/ConsentFormWrapper";
import { isDraftSaveableStatus } from "../helpers/client-forms.helpers";

export default function ConsentFormPage() {
    const params = useParams();

    const { bookingId } = params;

    const { data, isLoading, isError } = useGetConsentByBookingId(
        bookingId ?? ""
    );

    const consent = data?.data;

    if (isLoading) {
        return (
            <>
                <Navbar title="Consent Form" />
                <div className="p-32">
                    <p className="text-sm text-[rgba(11,19,43,0.5)]">
                        Loading...
                    </p>
                </div>
            </>
        );
    }

    if (isError || !consent) {
        return (
            <>
                <Navbar title="Consent Form" />
                <div className="p-32">
                    <p className="text-sm text-[rgba(11,19,43,0.5)]">
                        Unable to load consent form. Please try again or contact
                        support.
                    </p>
                </div>
            </>
        );
    }

    const formConfig = consent.form_definition;

    if (!formConfig) {
        return (
            <>
                <Navbar title="Consent Form" />
                <div className="p-32">
                    <p className="text-sm text-[rgba(11,19,43,0.5)]">
                        This form is not yet available in the portal. Please use
                        the link provided in your email.
                    </p>
                </div>
            </>
        );
    }

    const isDraftSaveable = isDraftSaveableStatus(consent.status);
    const hasSubmitted =
        !isDraftSaveable &&
        (consent.client_submitted ||
            consent.status === FormStatus.RECEIVED ||
            consent.status === FormStatus.COMPLETED);

    if (!isDraftSaveable && !hasSubmitted) {
        return (
            <>
                <Navbar title="Consent Form" />
                <div className="p-32">
                    <Card classNames="p-24">
                        <p className="text-base font-semibold text-[#0B132B] mb-8">
                            Consent form unavailable
                        </p>
                        <p className="text-sm text-[rgba(11,19,43,0.6)]">
                            This consent form is unavailable. Please contact
                            your provider for help.
                        </p>
                    </Card>
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar title={formConfig.label} />
            <ConsentFormWrapper initialConsent={consent} />
        </>
    );
}
